import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Rodal from 'rodal'
import Tutorial from '../../generic/CourseSummary'
import './styles.css'

class RelatedModal extends Component {
  constructor() {
    super()
    this.getTitle = this.getTitle.bind(this)
    this.getFullSlug = this.getFullSlug.bind(this)
  }

  getFullSlug(slug) {
    // Update route while preserving previous query params
    const searchParams = new URLSearchParams(window.location?.search)
    // If basic subscriber, don't enable auto-play so they can see credit consumption warning
    searchParams.set('watch', this.props.isBasicSubscriber ? 0 : 1)
    searchParams.delete('chapter')

    return `${slug}?${searchParams.toString()}`
  }

  getTitle() {
    const { learningPath } = this.props
    const title = learningPath ? learningPath.title : ''
    if (window.location.search !== '') return `Next on your ${title} pathway`
    return 'Explore related courses'
  }

  render() {
    const { visible, close, isMobile, recommends } = this.props

    return (
      <div id="RelatedModal">
        {visible && (
          <Rodal
            visible={visible}
            onClose={() => close()}
            width={isMobile ? 350 : 700}
            height={500}
          >
            <div className="related-modal-rodal">
              <header className="header">
                <h2>{this.getTitle()}</h2>
              </header>
              <div className="recommend-list">
                {recommends && recommends.map((tutorial) => (
                  <div
                    className="tutorial"
                    key={`tutorial-${tutorial.id}`}
                    onClick={() => close()}
                    onKeyDown={(e) => e.key === 'Enter' && close()}
                    role="button"
                    tabIndex={0}
                  >
                    <Tutorial
                      slug={this.getFullSlug(tutorial.slug)}
                      summary={tutorial.description}
                      teacher={tutorial.artist.title}
                      teacherSlug={tutorial.artist.slug}
                      title={tutorial.title}
                      thumb={tutorial.photo.boxThumb}
                      variant="darkContentText"
                      new={tutorial.new}
                    />
                  </div>
                ))}
              </div>
            </div>
          </Rodal>
        )}
      </div>
    )
  }
}

RelatedModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  recommends: PropTypes.arrayOf(PropTypes.object),
  learningPath: PropTypes.shape({
    title: PropTypes.string
  }),
  isBasicSubscriber: PropTypes.bool
}

RelatedModal.defaultProps = {
  recommends: [],
  learningPath: null,
  isBasicSubscriber: false
}

export default RelatedModal
